import { create } from 'zustand';

interface FeedbackPanelState {
  open: boolean;
  openPanel: () => void;
  closePanel: () => void;
}

export const useFeedbackPanelStore = create<FeedbackPanelState>((set) => ({
  open: false,
  openPanel: () => set({ open: true }),
  closePanel: () => set({ open: false }),
}));
